/** Returns the primary role key for i18n lookup, handling both string and array inputs. */
export function formatAdminRoles(roles: string | string[] | undefined): string {
  if (!roles) return '';
  if (typeof roles === 'string') return roles;
  return roles[0] ?? '';
}
